<mat-dialog-content class="mat-typography guru-dialog-content">
  <img src="/assets/images/guru_badge.png" alt="SalesMail Guru badge" class="guru-dialog-badge" />
  <h2 class="guru-dialog-title">Guru Achievement!</h2>
  <p class="guru-dialog-body">
    Congratulations on reaching Guru status! Share your achievement and learn more about this exclusive rank.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="center" class="guru-dialog-actions">
  <button mat-button mat-dialog-close>DISMISS</button>
  <button mat-flat-button color="primary" (click)="shareBadge()" cdkFocusInitial>SHARE BADGE</button>
</mat-dialog-actions>
